/**
 * Phase 17 — kickoff card picker rendered as Stella's first turn on a
 * fresh chat. Wraps `OptionsCardGrid` with intent-specific copy so the
 * customer has a tappable on-ramp ("Kitchen / Bathroom / Siding / Patio
 * / Other").
 */

import type { ChatMessage, OptionsCardPayload } from "@starz/shared/api/types.gen";

import { OptionsCardGrid } from "./OptionsCardGrid";

interface Props {
  message: Pick<ChatMessage, "content" | "options_payload">;
  onSelectIntent: (intentId: string, displayName: string) => void;
  disabled?: boolean;
}

export function IntentPicker({ message, onSelectIntent, disabled }: Props) {
  const payload = message.options_payload as OptionsCardPayload | null | undefined;
  if (!payload || payload.cards.length === 0) {
    return null;
  }
  return (
    <div className="space-y-3">
      {message.content ? (
        <div className="max-w-prose rounded-2xl rounded-bl-md border border-starz-gold/20 bg-starz-cream px-5 py-3 text-base text-starz-charcoal">
          {message.content}
        </div>
      ) : null}
      <OptionsCardGrid
        payload={payload}
        selectedOptionId={null}
        disabled={disabled === true}
        onSelect={(card) => onSelectIntent(card.option_id, card.display_name)}
      />
    </div>
  );
}
